// extracted by mini-css-extract-plugin
module.exports = {"root":"InlinedImageBlock-module--root--1a9Sw","image":"InlinedImageBlock-module--image--1Fu7V","text":"InlinedImageBlock-module--text--2w4Ko"};